define('../src/sublayouts/m1-hero/m1-hero',['jquery', 'slick', 'lib/utils', 'tooltipster', 'breakpoint', ], function($, slick, utils, tooltipster, breakpoint) {

    'use strict';

    var M1_HERO = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M1_HERO.prototype.init = function() {
        var _this = this,
            wheight = $(window).height(),
            isloaded = false,
            type = this.$component.attr('data-type'),
            addToCal = this.$component.find('.icon-calendar');

        $('.m1-hero--video').on('load', function() {
        _this.reHeight(true);
        });
        _this.reHeight(true);

        $(window).on('resize', function() {
            _this.reHeight(false);
            //console.log('asdasdasdasdasdas')
        })

        $(window).on('orientationchange', function() {
            _this.reHeight(false);
        });

        $('.m1-hero_explore-link').on('click', function(e) {
            e.preventDefault()
            $('html,body').animate({ scrollTop: $(window).height() }, 'slow');
        });

        if (!isloaded) {
            if(type == "video"){
                checkLoad();
            }
        };

        function checkLoad() {
            if (document.querySelector('.m1-hero--video').readyState === 4) {
                $(window).trigger('resize');
                isloaded = true;
            } else {
                setTimeout(checkLoad, 20);
            }
        }

        addToCal.on('click',function(){
            if(!$(this).hasClass('calactive')){
                $(this).addClass('calactive')
            }else{
                $(this).removeClass('calactive')
            }
        })
    };

    M1_HERO.prototype.reHeight = function(isLoad) {
        var isloaded = false,
            type = this.$component.attr('data-type');

        /*if ($(window).width() <= 1024) {
                //if (!navigator.userAgent.match(/iPad/i) != null) {
                //    $('.m1-hero--video').find('source').attr('src', $('.m1-hero--video').attr('data-mobile'));
                //    if (isLoad) {
                //        $('.m1-hero--video')[0].load();
                //    };
                //} else {
                //    $('.m1-hero--video').find('source').attr('src', $('.m1-hero--video').attr('data-desktop'));
                //    if (isLoad) {
                //        $('.m1-hero--video')[0].load();
                //    }
                //};
            $('.m1-hero__wrapper').css('height', 'auto')
        } else if ($(window).width() > 820) {
            //$('.m1-hero--video').find('source').attr('src', $('.m1-hero--video').attr('data-desktop'));
            //if (isLoad) {
            //    $('.m1-hero--video')[0].load();
            //}
            $('.m1-hero__wrapper').css('height', $(window).height())
        }*/

        if ($(window).width() <= 1024) {
            if(type == "video"){
                $('.m1-hero--video').find('source').attr('src', $('.m1-hero--video').attr('data-mobile'));
                if (isLoad) {
                    $('.m1-hero--video')[0].load();
                }
                $('.m1-hero__wrapper').css('height', 'auto')
            }
        }
        if ($(window).width() > 1024) {
            if(type == "video"){
                $('.m1-hero--video').find('source').attr('src', $('.m1-hero--video').attr('data-desktop'));
                if (isLoad) {
                    $('.m1-hero--video')[0].load();
                }
                $('.m1-hero__wrapper').css('height', $(window).height())
            }
        }

        function setHeight(){
            var winWidth = $(window).width(),
            brakePoint = 1024,
            videoHeight = 580,
            calcWidth = (winWidth - brakePoint ) / brakePoint;
            
            if(!calcWidth == 0){
                videoHeight =  (videoHeight + (videoHeight * calcWidth))
            }
            $('.m1-hero--video').css({
                height: videoHeight + 'px'
            });
        }

        function checkLoad() {
            if (document.querySelector('.m1-hero--video').readyState === 4) {
                var suma = (($(window).width() - $('.m1-hero--video').width()) / 2).toString();
                $('.m1-hero--video').css({
                    right: suma + 'px',
                    opacity: '1'
                });
                isloaded = true;
                if ($(window).width() <= 1024) {
                    setHeight()
                }
            } else {
                setTimeout(checkLoad, 20);
            }
        };

        if (!isloaded) {
            if(type == "video"){
                checkLoad();
            }
        };

    }



    return M1_HERO;
});

